(function (){
    $('.singlePartner').hover(
        function(){
            let imgPartner = $(this).find('.partnersLogo')[0];
            let orgTitle = $(this).find('.orgTitle')[0];
            $(imgPartner).animate({ width: '90',marginRight: "1.8in", marginBottom: "20%"}, 600);
            $(orgTitle).css({display: 'block'});
            $(orgTitle).animate({marginTop: '60px', opacity: 1}, 400);
        },
        function(){
            let imgPartner = $(this).find('.partnersLogo')[0];
            let orgTitle = $(this).find('.orgTitle')[0];
            $(imgPartner).animate({ width: '170', marginRight: "0", marginBottom: "0" }, 400);
            $(orgTitle).animate({marginTop: '90px', opacity: 0}, 400);
            $(orgTitle)
                .delay(50)
                .queue(function (next) {
                    $(this).css('display', 'none');
                    next();
                });
        }
    );
})(jQuery);